export enum ApplicationStage {
  KeymanCbsChecking = 'keyman-cbs-checking',
  KeymanCbsPassed = 'keyman-cbs-passed',
  KeymanCbsFailed = 'keyman-cbs-failed',
  LoAssigned = 'lo-assigned',
}
